/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import React from "react";
import cn from "classnames";
import s from "./Overlay.module.css";
import { useAnimatedUnmount } from "hooks/useAnimatedUnmount";

interface OverlayProps {
  isOpen: boolean;
  onClick?: () => void;
  children?: React.ReactNode;
  variant: "page" | "component";
  className?: string;
}

const DURATION = 500;

const Overlay = ({
  isOpen,
  children,
  variant,
  className,
  ...rest
}: OverlayProps) => {
  const { showComponent, style } = useAnimatedUnmount(isOpen, DURATION);

  React.useEffect(() => {
    if (isOpen) {
      document.body.className = "overflow-hidden";
    } else {
      document.body.className = "overflow-auto";
    }

    return () => {
      document.body.className = "overflow-auto";
    };
  }, [isOpen]);

  const onClick = () => {
    if (rest.onClick) {
      rest.onClick();
    }
  };

  return showComponent ? (
    <div
      style={style}
      onClick={onClick}
      className={cn(
        s.root,
        variant && s[variant],
        className,
        "overlay-container",
      )}
      test-id="TLUkv_cZ"
    >
      {children}
    </div>
  ) : null;
};

export default Overlay;
